import React from "react"
import {Redirect, Router} from "@reach/router"
import {NotFound} from "@indebted/components/Error"
import {LoginCallback} from "@okta/okta-react"

import {ClientFiles} from "./views/ClientFiles"
import {ClientFile} from "./views/ClientFile"
import {SecureRoute} from "./components/SecureRoute"

function Routes() {
	return (
		<Router>
			<LoginCallback path="/login/callback" />
			<Redirect from="/" to="/client-files" noThrow />

			<SecureRoute path="/client-files" component={ClientFiles} />
			<SecureRoute path="/client-file" component={ClientFile} />

			<NotFound default />
		</Router>
	)
}

export {Routes}
